import React, { useState, useEffect, useMemo } from "react";
import {
  Fab,
  Box,
  List,
  ListItemButton,
  Typography,
  Menu,
  MenuItem,
  Badge
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { Outlet, useLocation } from "react-router-dom";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import DashboardIcon from "@mui/icons-material/Dashboard";
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import SummarizeIcon from '@mui/icons-material/Summarize';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CampaignIcon from '@mui/icons-material/Campaign';
import BuildIcon from "@mui/icons-material/Build";
import SettingsIcon from "@mui/icons-material/Settings";
import TerminalIcon from "@mui/icons-material/Terminal";
import SyncAltOutlinedIcon from '@mui/icons-material/SyncAltOutlined';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SupportTicketModel from "./SupportTicketModel";
import AnalyticsIcon from '@mui/icons-material/Analytics';
import InsightsIcon from '@mui/icons-material/Insights';
import { getUnreadCountAnnouncementsSlice } from "../../redux/actions/getUnreadCountAnnouncementsSlice"
import { getAlertImmutableauditunreadCountSlice } from "../../redux/actions/getAlertImmutableauditunreadCountSlice"
import {
  getAlertImmutableauditunreadCountEndpoint,
  getAlertSupplierConfirmationunreadCountEndpoint,
  getAlertObsoleteunreadCountEndpoint,
  getUnreadAnnouncementCountEndpoint,
  getAlertSupplierUnconfirmedConsolidatedunreadCountEndpoint, getBuyerForecastHistoryNotificationsUnreadCountEndpoint
} from "../../common/endpoints";
import { useDispatch, useSelector } from "react-redux";
import { getAlertObsoleteSlice } from "../../redux/actions/getAlertObsoleteSlice";
import { getAlertObsoleteunreadCountSlice } from "../../redux/actions/getAlertObsoleteunreadCountSlice";
import { getAlertSupplierConfirmationunreadCountSlice } from "../../redux/actions/getAlertSupplierConfirmationunreadCountSlice";
import HistoryIcon from '@mui/icons-material/History';
import { clearGridSelectedRows } from '../../redux/actions/gridSelectedRowsSlice';
import { getAlertSupplierUnconfirmedConsolidatedSlice } from "../../redux/actions/getAlertSupplierUnconfirmedConsolidatedSlice";
import { getAlertSupplierUnconfirmedConsolidatedunreadCountSlice } from "../../redux/actions/getAlertSupplierUnconfirmedConsolidatedunreadCountSlice";
import { getBuyerForecastHistoryNotificationsUnreadCountSlice } from "../../redux/actions/getBuyerForecastHistoryNotificationsUnreadCountSlice";

const drawerWidth = 95;
const seaGreen = "#6AC9CE";

const MainContent = (props) => {
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElSecond, setAnchorElSecond] = useState(null);
  const [anchorElAdmin, setAnchorElAdmin] = useState(null); // Added state for Admin submenu
  const [anchorElForecast, setAnchorElForecast] = useState(null); // Added state for Forecast submenu
  const [anchorElSettings, setAnchorElSettings] = useState(null); // Added state for settings and configure submenu
  const [showSupportModal, setShowSupportModal] = useState(false);
  const roleDetails = localStorage.getItem("userRole");
  const isAppAdmin = roleDetails === "App Admin";
  const isSupplier = roleDetails === "Supplier Planner" || roleDetails === "Supplier Admin";
  const isViwer = roleDetails === "Global Viewer" || roleDetails === "Regional Viewer";
  const userEmail = localStorage.getItem("userEmail");
  const dispatch = useDispatch();
  const gridSelectedRows = useSelector((state) => state.gridSelectedRows.selectedRows);
  const [unreadCount, setUnreadCount] = useState(0)
  const [unreadAlertCount, setUnreadAlertCount] = useState(0)
  const [unreadImmutableAlertCount, setUnreadImmutableAlertCount] = useState(0)
  const [unreadForecastHistoryAlertCount, setUnreadForecastHistoryAlertCount] = useState(0)
  const [unreadSupplierAlertCount, setUnreadSupplierAlertCount] = useState(0)
  const [unreadSupplierUnconfirmAlertCount, setUnreadSupplierUnconfirmAlertCount] = useState(0)

  const handleMenuClick = (item, event) => {
    if (item.label === "Planning") {
      setAnchorEl(event.currentTarget);
    }
    if (item.label === "Announcements") {
      props.handleMenuItemClick(item.path, item.label, item);
    }
    else if (item.label === "Settings & Config") {
      // setAnchorElSettings(event.currentTarget);
      props.handleMenuItemClick(item.path, item.label, item);
    }
    else if (item.label === "Admin") {

      if (isAppAdmin) {
        //  APP_ADMIN → open submenu
        setAnchorElAdmin(event.currentTarget);
      }
      else {
        //  Other users → directly go to Manage Users page
        props.handleMenuItemClick(
          "/admin/manage-users",
          "Manage Users",
          { path: "/admin/manage-users", label: "Manage Users" }
        );
      }

    }
    else if (item.label === "Scheduler") {
      setAnchorElForecast(event.currentTarget);
    }
    else {
      props.handleMenuItemClick(item.path, item.label, item);
    }
  };

  const handleSubmenuClose = () => setAnchorEl(null);
  const handleSecondSubmenuClose = () => setAnchorElSecond(null);
  const handleAdminSubmenuClose = () => setAnchorElAdmin(null); // Close Admin submenu
  const handleForecastSubmenuClose = () => setAnchorElForecast(null); // Close Forecast submenu
  const handleSettingsSubmenuClose = () => {
    setAnchorElSettings(null);
  };

  useEffect(() => {
    fetchUnreadCount();
    fetchAlertUnreadCount();
    fetchAlertImmutableUnreadCount();
    fetchForecastHistoryAlertUnreadCount();
    fetchAlertSupplierUnreadCount();
    fetchAlertSupplierUnconfirmUnreadCount();

    const interval = setInterval(() => {
      fetchUnreadCount();
      fetchAlertUnreadCount();
      fetchAlertImmutableUnreadCount();
      fetchForecastHistoryAlertUnreadCount();
      fetchAlertSupplierUnreadCount();
      fetchAlertSupplierUnconfirmUnreadCount();
    }, 15000); // refresh every 15 sec

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      const menuEls = document.querySelectorAll(".MuiMenu-paper");

      // check if click is inside any open menu
      const clickedInsideMenu = Array.from(menuEls).some((menu) =>
        menu.contains(event.target)
      );

      // check if click is inside the sidebar button (so menu toggle still works)
      const clickedOnAnchor =
        anchorEl?.contains(event.target) ||
        anchorElSecond?.contains(event.target) ||
        anchorElAdmin?.contains(event.target) || // Check for Admin anchor
        anchorElForecast?.contains(event.target); // Check for Forecast anchor

      if (!clickedInsideMenu && !clickedOnAnchor) {
        setAnchorEl(null);
        setAnchorElSecond(null);
        setAnchorElAdmin(null); // Close Admin menu
        setAnchorElForecast(null); // Close Forecast menu
      }
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [anchorEl, anchorElSecond, anchorElAdmin, anchorElForecast]);

  const fetchUnreadCount = async () => {
    try {
      const response = await dispatch(
        getUnreadCountAnnouncementsSlice({
          dynamicEndpoint: getUnreadAnnouncementCountEndpoint,
        })
      );

      if (response?.meta?.requestStatus === "fulfilled") {
        setUnreadCount(response.payload?.unreadCount || 0);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAlertUnreadCount = async () => {
    try {
      const response = await dispatch(
        getAlertObsoleteunreadCountSlice({
          dynamicEndpoint: `${getAlertObsoleteunreadCountEndpoint}/${encodeURIComponent(userEmail)}`,
          skipUserEmailParam: true,
        })
      );

      if (response?.meta?.requestStatus === "fulfilled") {
        setUnreadAlertCount(response.payload || 0);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAlertImmutableUnreadCount = async () => {
    try {
      const response = await dispatch(
        getAlertImmutableauditunreadCountSlice({
          dynamicEndpoint: `${getAlertImmutableauditunreadCountEndpoint}/${encodeURIComponent(userEmail)}`,
          skipUserEmailParam: true,
        })
      );
      if (response?.meta?.requestStatus === "fulfilled") {
        setUnreadImmutableAlertCount(response.payload || 0);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAlertSupplierUnreadCount = async () => {
    try {
      const response = await dispatch(
        getAlertSupplierConfirmationunreadCountSlice({
          dynamicEndpoint: `${getAlertSupplierConfirmationunreadCountEndpoint}/${encodeURIComponent(userEmail)}/unread-count`,
          skipUserEmailParam: true,
        })
      );

      if (response?.meta?.requestStatus === "fulfilled") {
        setUnreadSupplierAlertCount(response.payload || 0);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchForecastHistoryAlertUnreadCount = async () => {
    try {
      const response = await dispatch(
        getBuyerForecastHistoryNotificationsUnreadCountSlice({
          dynamicEndpoint: `${getBuyerForecastHistoryNotificationsUnreadCountEndpoint}/${encodeURIComponent(userEmail)}`,
          skipUserEmailParam: true,
        })
      );

      if (response?.meta?.requestStatus === "fulfilled") {
        const unreadCount = response?.payload?.unreadCount ?? response?.payload ?? 0;
        setUnreadForecastHistoryAlertCount(unreadCount);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAlertSupplierUnconfirmUnreadCount = async () => {
    try {
      const response = await dispatch(
        getAlertSupplierUnconfirmedConsolidatedunreadCountSlice({
          dynamicEndpoint: `${getAlertSupplierUnconfirmedConsolidatedunreadCountEndpoint}/${encodeURIComponent(userEmail)}`,
          skipUserEmailParam: true,
        })
      );

      if (response?.meta?.requestStatus === "fulfilled") {
        setUnreadSupplierUnconfirmAlertCount(response.payload || 0);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const renderNavButton = (item) => {
    const forecastPaths = ["/forecastHistoryPage", "/run-forecast-extraction"];
    const isActive =
      location.pathname === item.path ||
      location.pathname.startsWith(item.path + "/") ||
      (item.label === "Scheduler" && forecastPaths.includes(location.pathname));
    const ICON_MAP = {
      dashboard: DashboardIcon,
      planning: InsertChartIcon,
      poExceptionManagement: SyncAltOutlinedIcon,
      reports: SummarizeIcon,
      admin: SupervisorAccountIcon,
      kpimetrics: TrackChangesIcon,
      alerts: NotificationsIcon,
      announcements: CampaignIcon,
      adminTraining: BuildIcon,
      training: TerminalIcon,
      settingsConfig: SettingsIcon,
      ticketsummary: SummarizeIcon,
      forecastHistory: HistoryIcon,
      forecast: HistoryIcon,
      scheduler: CalendarMonthIcon,
      extractForecastFromSAP: SyncAltOutlinedIcon,
      supplierConfirmationAnalytics: InsightsIcon
    };
    const IconComponent = ICON_MAP[item.icon]
    return (
      <ListItemButton
        key={item.label}
        onClick={(e) => handleMenuClick(item, e)}
        disabled={item.disabled}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          backgroundColor: isActive ? seaGreen : "",
          color: isActive ? "white" : "black",
          "&:hover": { backgroundColor: seaGreen },
          // mb: 0.5,
          // py: 1,
          p: 1
        }}
      >
        <Box sx={{ color: isActive ? "#fff" : "#000", mt: 0.4 }}>
          {item.label === "Announcements" && !isAppAdmin ? (
            <Badge
              badgeContent="NEW"
              color="error"
              invisible={unreadCount === 0}
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: "8px",
                  minWidth: "22px",
                  height: "14px",
                },
              }}
            >
              <IconComponent />
            </Badge>
          ) : item.label === "Alerts" && !isSupplier ? (
            <Badge
              badgeContent="NEW"
              color="error"
              invisible={unreadAlertCount === 0 && unreadImmutableAlertCount === 0 && unreadForecastHistoryAlertCount === 0}
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: "8px",
                  minWidth: "22px",
                  height: "14px",
                },
              }}
            >
              <IconComponent />
            </Badge>
          ) : item.label === "Alerts" && isSupplier ? (
            <Badge
              badgeContent="NEW"
              color="error"
              invisible={unreadSupplierAlertCount === 0 && unreadSupplierUnconfirmAlertCount === 0}
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: "8px",
                  minWidth: "22px",
                  height: "14px",
                },
              }}
            >
              <IconComponent />
            </Badge>
          ) : (
            IconComponent && <IconComponent />
          )}
        </Box>
        <Typography
          variant="caption"
          sx={{
            fontSize: "0.75rem",
            fontWeight: 500,
            letterSpacing: 0.3,
            color: isActive ? "#fff" : "#000",
            textAlign: "center",
            mt: 0.5,
            textDecoration: item?.redirect ? "underline" : "none",
          }}
        >
          {item.label}
        </Typography>
      </ListItemButton>
    );
  };

  // Determine if sidebar should be hidden
  const hideSidebarRoutes = ["/landing-page", "/login", "/"];
  const hideSidebar = hideSidebarRoutes.includes(location.pathname);
  const isCPSActive = location.pathname === "/forecastCollab-cps";
  const isDPSActive = location.pathname === "/forecastCollab-dps";

  const handleAddLTSupportClick = () => {
    setShowSupportModal(true);
  }

  const orderedMenuItems = useMemo(() => {
    const safeItems = Array.isArray(props.menuItems) ? props.menuItems : [];

    return [...safeItems].sort((a, b) => {
      const aIsTicketSummary = a?.label === "Ticket Summary";
      const bIsTicketSummary = b?.label === "Ticket Summary";

      if (aIsTicketSummary && !bIsTicketSummary) {
        return 1;
      }

      if (!aIsTicketSummary && bIsTicketSummary) {
        return -1;
      }

      return 0;
    });
  }, [props.menuItems]);

  return (
    <Box sx={{ display: "flex" }}>
      {/* Sidebar - show only if not landing page */}
      {!hideSidebar && (
        <Box
          sx={{
            width: drawerWidth,
            backgroundColor: "#ddd",
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flexShrink: 0,

          }}
        >
          {/* Menu */}
          <Box sx={{ width: "100%" }}>
            <List sx={{ width: "100%" }}>
              {orderedMenuItems.map((item) => renderNavButton(item))}
            </List>
          </Box>

          {/* Bottom link */}
          {isSupplier && <Box
            sx={{
              textAlign: "center",
              mt: "auto",
              width: "100%",
              px: 1,
              pb: 5,
            }}
          >
            <Box
              component="a"
              href={process.env.REACT_APP_POCOLLABORATION_URL}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "inline-flex",   // 👈 IMPORTANT (prevents layout break)
                alignItems: "center",
                justifyContent: "center",
                width: "100%",            // keeps full clickable area
                color: "black",
                fontWeight: 500,
                py: "8px",
                fontSize: "12px",
                lineHeight: "16px",
                textDecoration: "underline",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: seaGreen,
                },
              }}
            >
              Redirect to SAP Ariba PO collaboration
            </Box>
          </Box>}
        </Box>
      )}

      {/* Submenu for Planning */}
      {!hideSidebar && anchorEl && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleSubmenuClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              backgroundColor: "#ddd",
              color: "#000",
              border: "1px solid #000",
              boxShadow: "none",
              "& .MuiMenuItem-root": {
                fontSize: "13px",
                paddingY: "8px",
                paddingX: "24px",
                minWidth: "120px",
                minHeight: "50px",
                border: "1px solid transparent", // default no visible border
                "&:hover": {
                  // border: "1px solid #000", // show black border on hover
                  backgroundColor: "transparent", // no color change
                },
              },
            },
          }}

        >
          <MenuItem onClick={(e) => setAnchorElSecond(e.currentTarget)} sx={{ mx: 0.5 }}>
            <Typography sx={{ fontSize: "16px" }}>
              Forecast
            </Typography>
            <KeyboardArrowRightIcon fontSize="small" />
          </MenuItem>
          <Menu
            anchorEl={anchorElSecond}
            open={Boolean(anchorElSecond)}
            onClose={handleSecondSubmenuClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            PaperProps={{
              sx: {
                backgroundColor: "#ddd",
                color: "#000",
                border: "1px solid #000",
                boxShadow: "none",
                mt: -1,
                ml: 0.5,
                "& .MuiMenuItem-root": {
                  fontSize: "13px",
                  paddingY: "6px",
                  paddingX: "20px",
                  minWidth: "130px",
                  minHeight: "50px",
                  border: "1px solid transparent", // default no border
                  transition: "border-color 0.1s ease",
                  "&:hover": {
                    border: "1.5px solid #000", // show black border on hover
                    // backgroundColor: "#ddd", // keep same background

                  },
                },
              },
            }}
          >
            <MenuItem
              onClick={() => {
                props.handleMenuItemClick(
                  "/forecastCollab-cps",
                  "Planning",
                  { path: "/forecastCollab-cps", label: "Forecast" }
                );
                setAnchorEl(null);
                setAnchorElSecond(null);
              }}
              sx={{
                mx: 0.5, backgroundColor: isCPSActive ? seaGreen : "",
                color: isCPSActive ? "white" : "black",
                "&:hover": {
                  backgroundColor: isCPSActive ? seaGreen : "",
                  color: isCPSActive ? "white" : "black",
                },
              }}
            >
              CPS
            </MenuItem>
            <MenuItem
              onClick={() => {
                props.handleMenuItemClick(
                  "/forecastCollab-dps",
                  "Planning",
                  { path: "/forecastCollab-dps", label: "Forecast" }
                );
                setAnchorEl(null);
                setAnchorElSecond(null);
              }}
              sx={{
                mx: 0.5, backgroundColor: isDPSActive ? seaGreen : "",
                color: isDPSActive ? "white" : "black",
                "&:hover": {
                  backgroundColor: isDPSActive ? seaGreen : "",
                  color: isDPSActive ? "white" : "black",
                },
              }}
            >
              DPS
            </MenuItem>
          </Menu>
        </Menu>
      )}

      {/* Submenu for Admin */}
      {!props.hideSidebar && isAppAdmin && anchorElAdmin && (
        <Menu
          anchorEl={anchorElAdmin}
          open={Boolean(anchorElAdmin)}
          onClose={handleAdminSubmenuClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              color: "#000",
              border: "1px solid #000",
              boxShadow: "none",
              "& .MuiMenuItem-root": {
                fontSize: "13px",
                paddingY: "2px",
                paddingX: "18px",
                minWidth: "120px",
                minHeight: "40px",
                border: "1px solid transparent",
                // "&:hover": {
                //   backgroundColor: "transparent",
                // },
              },
            },
          }}
        >
          {/* MenuItem for "Manage Users" */}
          <MenuItem
            component="div"
            onClick={() => {
              props.handleMenuItemClick(
                "/admin/manage-users",
                "Manage Users",
                { path: "/admin/manage-users", label: "Manage Users" }
              );
              setAnchorElAdmin(null);
            }}
            sx={{
              "&:hover": {
                backgroundColor:
                  location.pathname === "/admin/manage-users"
                    ? "#6AC9CE"   // ⬅️ keep same if active
                    : "#f0f0f0", // ⬅️ hover only when inactive
              },
              color: location.pathname === "/admin/manage-users" ? "white" : "black", // Active background
              backgroundColor: location.pathname === "/admin/manage-users" ? "#6AC9CE" : "transparent", // Active background
            }}
          >
            Manage Users
          </MenuItem>

          {/* MenuItem for "Manage Reason Names" */}
          <MenuItem
            component="div"
            onClick={() => {
              props.handleMenuItemClick(
                "/admin/manage-reason-codes",
                "Admin",
                { path: "/admin/manage-reason-codes", label: "Admin" }
              );
              setAnchorElAdmin(null);
            }}
            sx={{
              "&:hover": {
                backgroundColor:
                  location.pathname === "/admin/manage-reason-codes"
                    ? "#6AC9CE"
                    : "#f0f0f0",
              },
              backgroundColor: location.pathname === "/admin/manage-reason-codes" ? "#6AC9CE" : "transparent", // Active background
              color: location.pathname === "/admin/manage-reason-codes" ? "white" : "black", // Active background
            }}
          >
            Manage Reason Names
          </MenuItem>

          {/* Add other admin-related menu items here */}
          {/* MenuItem for "Manage Domain Whitelisting" */}
          <MenuItem
            component="div"
            onClick={() => {
              props.handleMenuItemClick(
                "/admin/manage-domain-whitelisting",
                "Admin",
                { path: "/admin/manage-domain-whitelisting", label: "Admin" }
              );
              setAnchorElAdmin(null);
            }}
            sx={{
              "&:hover": {
                backgroundColor:
                  location.pathname === "/admin/manage-domain-whitelisting"
                    ? "#6AC9CE"
                    : "#f0f0f0",
              },
              backgroundColor: location.pathname === "/admin/manage-domain-whitelisting" ? "#6AC9CE" : "transparent", // Active background
              color: location.pathname === "/admin/manage-domain-whitelisting" ? "white" : "black", // Active background
            }}
          >
            Manage Domain Whitelisting
          </MenuItem>

        </Menu>
      )}

      {/* Submenu for Forecast */}
      {!hideSidebar && anchorElForecast && (
        <Menu
          anchorEl={anchorElForecast}
          open={Boolean(anchorElForecast)}
          onClose={handleForecastSubmenuClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              color: "#000",
              border: "1px solid #000",
              boxShadow: "none",
              "& .MuiMenuItem-root": {
                fontSize: "13px",
                paddingY: "2px",
                paddingX: "18px",
                minWidth: "120px",
                minHeight: "40px",
                border: "1px solid transparent",
              },
            },
          }}
        >
          {/* Forecast History */}
          <MenuItem
            component="div"
            onClick={() => {
              props.handleMenuItemClick(
                "/forecastHistoryPage",
                "Forecast History",
                { path: "/forecastHistoryPage", label: "Forecast History" }
              );
              setAnchorElForecast(null);
            }}
            sx={{
              "&:hover": {
                backgroundColor:
                  location.pathname === "/forecastHistoryPage" ? "#6AC9CE" : "#f0f0f0",
              },
              backgroundColor: location.pathname === "/forecastHistoryPage" ? "#6AC9CE" : "transparent",
              color: location.pathname === "/forecastHistoryPage" ? "white" : "black",
            }}
          >
            Forecast History
          </MenuItem>

          {/* Extract Forecast From SAP - only for non-supplier roles */}
          {!isSupplier && !isViwer && (
            <MenuItem
              component="div"
              onClick={() => {
                props.handleMenuItemClick(
                  "/run-forecast-extraction",
                  "Run Forecast Extraction",
                  { path: "/run-forecast-extraction", label: "Run Forecast Extraction" }
                );
                setAnchorElForecast(null);
              }}
              sx={{
                "&:hover": {
                  backgroundColor:
                    location.pathname === "/run-forecast-extraction" ? "#6AC9CE" : "#f0f0f0",
                },
                backgroundColor: location.pathname === "/run-forecast-extraction" ? "#6AC9CE" : "transparent",
                color: location.pathname === "/run-forecast-extraction" ? "white" : "black",
              }}
            >
              Run Forecast Extraction
            </MenuItem>
          )}
        </Menu>
      )}

      {/* Submenu for Settings & Configuration */}
      {/* {!props.hideSidebar && isAppAdmin && anchorElSettings && (
        <Menu
          anchorEl={anchorElSettings}
          open={Boolean(anchorElSettings)}
          onClose={handleSettingsSubmenuClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              color: "#000",
              border: "1px solid #000",
              boxShadow: "none",
              "& .MuiMenuItem-root": {
                fontSize: "13px",
                paddingY: "2px",
                paddingX: "18px",
                minWidth: "250px",
                minHeight: "40px",
              },
            },
          }}
        >
          <MenuItem
            onClick={() => {
              props.handleMenuItemClick(
                "/settings-config/forecast-review-period",
                "Forecast Review Period Configuration",
                {
                  path: "/settings-config/forecast-review-period",
                  label: "Forecast Review Period Configuration",
                }
              );

              setAnchorElSettings(null);
            }}
            sx={{
              "&:hover": {
                backgroundColor:
                  location.pathname === "/settings-config/forecast-review-period"
                    ? "#6AC9CE"
                    : "#f0f0f0",
              },
              backgroundColor:
                location.pathname === "/settings-config/forecast-review-period"
                  ? "#6AC9CE"
                  : "transparent",
              color:
                location.pathname === "/settings-config/forecast-review-period"
                  ? "white"
                  : "black",
            }}
          >
            Forecast Review Period Configuration
          </MenuItem>

          <MenuItem
            onClick={() => {
              props.handleMenuItemClick(
                "/settings-config/forecast-publish-exclusion",
                "Forecast Publish Restriction",
                {
                  path: "/settings-config/forecast-publish-exclusion",
                  label: "Forecast Publish Restriction",
                }
              );

              setAnchorElSettings(null);
            }}
            sx={{
              "&:hover": {
                backgroundColor:
                  location.pathname === "/settings-config/forecast-publish-exclusion"
                    ? "#6AC9CE"
                    : "#f0f0f0",
              },
              backgroundColor:
                location.pathname === "/settings-config/forecast-publish-exclusion"
                  ? "#6AC9CE"
                  : "transparent",
              color:
                location.pathname === "/settings-config/forecast-publish-exclusion"
                  ? "white"
                  : "black",
            }}
          >
            Forecast Publish Restriction
          </MenuItem>
        </Menu>
      )} */}

      {/* Content */}
      <Box
        sx={{
          // marginLeft: hideSidebar ? 0 : `${drawerWidth}px`,
          flex: 1,
          paddingLeft: 2,
        }}
      >
        <Outlet />
      </Box>
      <div className="content">
        <div>

          {!isViwer && location.pathname !== "/ticketsummary" && (
            <Fab
              variant="extended"
              // disabled={location.pathname === "/ticketsummary"}
              style={{
                position: "fixed",
                bottom: "5px",
                left: "2px",
                zIndex: 1000,
                background: "#64cac6",
                // background: `${(location.pathname === "/ticketsummary") ? '#0000001f' : "#64cac6"}`,
                color: "#fff",
                // padding: '10px 10px',
                margin: '10px 0 0 10px',
                boxShadow: "0px 3px 5px -1px rgba(0,0,0,1.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)"
              }}
              onClick={handleAddLTSupportClick}
            >
              <AddIcon sx={{ mr: 1 }} />
              Support
            </Fab>
          )}

        </div>
        <SupportTicketModel
          showModal={showSupportModal}
          title="Support Ticket"
          menuItems={props.menuItems}
          handleClose={() => {
            setShowSupportModal(false);
            dispatch(clearGridSelectedRows());
          }}
          userEmail={userEmail}
          selectedItem={gridSelectedRows}
        />
      </div>
    </Box>
  );
};

export default MainContent;